import { Box, Chip } from "@mui/material";
import {
	BooleanField,
	BooleanInput,
	Datagrid,
	DateField,
	EditButton,
	EmailField,
	ExportButton,
	FilterButton,
	List,
	SelectInput,
	ShowButton,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { SoftDeleteToggle } from "@/components/SoftDeleteToggle";
import { BanButton } from "./BanButton";
import { ImpersonateButton } from "./ImpersonateButton";
import { RoleField } from "./RoleField";

const userFilters = [
	<TextInput key="email" label="Email" source="email" alwaysOn />,
	<TextInput key="name" label="Name" source="name" />,
	<SelectInput
		key="role"
		label="Role"
		source="role"
		choices={[
			{ id: "user", name: "User" },
			{ id: "admin", name: "Admin" },
			{ id: "super_admin", name: "Super Admin" },
		]}
	/>,
	<BooleanInput key="banned" label="Banned" source="banned" />,
	<BooleanInput
		key="emailVerified"
		label="Email Verified"
		source="emailVerified"
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<ExportButton />
		<SoftDeleteToggle />
	</TopToolbar>
);

const StatusChips = () => {
	const record = useRecordContext();
	if (!record) return null;

	return (
		<Box sx={{ display: "flex", gap: 0.5 }}>
			{record.banned && <Chip label="Banned" size="small" color="error" />}
			{record.deletedAt && (
				<Chip label="Deleted" size="small" color="default" />
			)}
			{!record.emailVerified && (
				<Chip label="Unverified" size="small" color="warning" />
			)}
		</Box>
	);
};

export const UserList = () => (
	<List
		filters={userFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid rowClick="show" bulkActionButtons={false}>
			<TextField source="name" />
			<EmailField source="email" />
			<RoleField />
			<BooleanField source="emailVerified" label="Verified" />
			<StatusChips />
			<DateField source="createdAt" label="Created" />
			<BanButton />
			<ImpersonateButton />
			<EditButton />
			<ShowButton />
		</Datagrid>
	</List>
);
